import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_SEARCH_CANDIDATE_GROUP_AMENDMENT_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../../api';
import { ApiPathParam } from '../../models/SearchParamSchema';
import { PaginatedData } from '../../models/List';

interface PostSearchCandidateRequest {
  body: {
    q?: string;
    examType: string;
  };
  apiParams: ApiPathParam;
}

export interface SearchSubjectOptionalPapers {
  uuid: string;
  paperNo: string;
}

export interface SearchSubjectResponse {
  subjectName: string;
  subjectCode: string;
  optionalPapers: SearchSubjectOptionalPapers[];
}

export interface PostSearchCandidateResponse {
  uuid: string;
  candidateId: string;
  name: string;
  examSeries: string[];
  examLevels: string[];
  subjects: SearchSubjectResponse[];
  status: string;
}

interface Input {
  onSuccess?: (data: PaginatedData<PostSearchCandidateResponse>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSearchCandidate = ({ onSuccess, onError }: Input) => {
  const postSearchCandidate = async (payload: PostSearchCandidateRequest) => {
    const res = await axiosClient.post<PaginatedData<PostSearchCandidateResponse>>(
      POST_SEARCH_CANDIDATE_GROUP_AMENDMENT_URL(payload.apiParams),
      payload.body
    );
    return res.data;
  };

  return useCustomMutation(postSearchCandidate, {
    onSuccess,
    onError,
  });
};
